const GetArray = (dataName) => JSON.parse(localStorage.getItem(dataName)) || [];
export const GetObject = (dataName) => JSON.parse(localStorage.getItem(dataName)) || {};
export default GetArray;
